<template>
  <div class="z-header">
    <OButton
      ref="searchPopperTrigger"
      pure
      class="u-center h-full w-12 hover:bg-alpha-5"
      :aria-label="$t('header.search')"
      @click="searchPopper.toggle"
    >
      <OIcon icon="search-dark" class="w-[18px]" />
    </OButton>
    <OPopper
      ref="searchPopperView"
      :is-visible="searchPopper.visible"
      class="bg-body-primary shadow-md border border-divider-100 min-w-[531px] p-6"
      use-show
    >
      <div class="relative">
        <input
          ref="inputElement"
          v-model="searchText"
          type="text"
          class="
            placeholder-alpha-60
            text-lg
            font-normal
            border border-divider-[#E2E5ED]
            rounded-md
            pl-4
            flex
            items-center
            w-full
            h-14
            bg-body-primary
          "
          :placeholder="$t('header.search-bar')"
          @keyup.enter="handleSearch"
          @click="handleSearchClick"
          @input="handleSearchChange"
        />
        <OButton
          pure
          class="w-12 h-12 bg-[#424242] rounded-md absolute right-1 top-1 u-center"
          :class="{ 'bg-[#d3d3d3] cursor-default': !isValidSearch }"
          @click="handleSearch"
        >
          <OIcon icon="search" svg-class="w-5 h-5" />
        </OButton>
      </div>
    </OPopper>
  </div>
</template>

<script>
import { defineComponent, watch, ref, nextTick, computed } from '@nuxtjs/composition-api';
import { OButton, OPopper, OIcon } from '~/modules/common/components/ui';
import { usePopper } from '~/composables/usePopper';
import { SEARCH_PATH, SEARCH_ARTICLE_PATH } from '~/constants/config';
import { onedioEvents } from '~/modules/tracking/scripts/onedioEvents';

export default defineComponent({
  components: {
    OButton,
    OPopper,
    OIcon,
  },
  setup() {
    const { sendSearchEvent } = onedioEvents();
    const inputElement = ref(null);
    const searchText = ref('');
    const [searchPopperTrigger, searchPopperView, searchPopper] = usePopper({ offset: [66, 0] });
    const isValidSearch = computed(() => {
      return searchText.value && searchText.value.trim() !== '' && searchText.value.trim().length >= 2;
    });

    const handleSearch = (event) => {
      if (isValidSearch.value) {
        sendSearchEvent('Search Interaction', 'Search Done', searchText.value);
        window.location.href = `/${SEARCH_PATH}/${SEARCH_ARTICLE_PATH}/${encodeURIComponent(searchText.value)}`;
      }
    };
    watch(
      () => searchPopper.visible,
      async (isVisible) => {
        if (isVisible) {
          // TODO: OInput sonrası prop ile ayarlanıcak
          await nextTick();
          inputElement.value.focus();
        }
      }
    );

    const handleSearchClick = () => {
      sendSearchEvent('Search Interaction', 'Search Opened', '');
    };

    const searchEventFired = ref(false);
    const handleSearchChange = () => {
      if (!searchEventFired.value) {
        sendSearchEvent('Search Interaction', 'Search Input', '');
        searchEventFired.value = true;
      }
    };

    return {
      searchPopperTrigger,
      searchPopperView,
      searchPopper,
      handleSearch,
      inputElement,
      searchText,
      isValidSearch,
      handleSearchClick,
      handleSearchChange,
    };
  },
});
</script>

<style></style>
